module.exports = __webpack_public_path__ + "static/media/sonder-header.e94d519a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder-header.jpg
// module id = 389
// module chunks = 0